<script>
import Layout from "../../layouts/main.vue";
import Heading from "../../layouts/heading.vue";
import FormBuilder from "../../layouts/FormBuilder.vue";
import { schema } from "./data";
import api from "../../../api";
import Swal from "sweetalert2";
import { v4 as uuidv4 } from 'uuid';

export default {
  props: {
    category: {},
  },
  components: { 
    FormBuilder, 
    Layout,
     Heading
      },
  data() {
    return {
      page: schema,
      currentTopicActiveStatus: false,
      location_list: [],
      topbar: {},
      selectedLocation: {},
    };
  },
  methods: {
    create() {
      if(this.selectedLocation.id) {
        var val = this.page.tabs.filter(tab => tab.name == this.selectedTab)[0].formData;
        var data = {
          uuid: uuidv4(),
          url: this.currentPractice.additionalProp1.url,
          active: true,
          title: val.date,
          picture: '',
          excerpt: 'Text here',
          description: '',
          deleted: false,          
          creationDate: new Date().toISOString(),
          lastModifiedDate: new Date().toISOString(),
          categoryId: this.category.id,
          cmsId: this.currentCms.id,
          pcnId: this.currentPracticeData.pcnId,
          additionalProp1: {
            reduced_hours: false,
            status: [
              {
                name: 'Closed',
                value: false
              },
              {
                name: 'Interim Closure',
                value: false
              }
            ],
            opening_time: '08:00',
            closing_time: '14:00',
            second_opening_time: '16:00',
            second_closing_time: '22:00',
            location_id: this.selectedLocation.id,
            dynamoId: this.currentPractice.additionalProp1.dynamo,            
          }
        };

        api.post('/api/categories/'+this.category.id+'/pages', data)
        .then((response) => {
          Swal.fire("Topic Added!", "Topic Added Successfully!", "success");
          this.page.tabs.filter(tab => tab.name == 'Practice Closure')[0].side_panel.dates.options.unshift(response.data); 
         
        }, (error) => {
          console.log(error);
        });
      }
      else {
          Swal.fire("No Location Selected!", "Please Select Location and try-again!", "warning");
      }

    },
    deleted() {
      var self = this;
      Swal.fire({
      title: `Are you sure you want to delete ${self.selectedItem.title}?`,
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#34c38f",
      cancelButtonColor: "#f46a6a",
      confirmButtonText: "Yes, delete it!"
      }).then(result => {
        if (result.value) {
          api.delete('/api/pages/'+this.selectedItem.id)
          .then(() => {
            Swal.fire("Topic Deleted!", "Topic Deleted Successfully!", "warning");
            this.page.tabs.filter(tab => tab.name == 'Practice Closure')[0].side_panel.dates.options
            .splice(
              this.page.tabs.filter(tab => tab.name == 'Practice Closure')[0].side_panel.dates.options.findIndex(function(i){
              return i.id === self.selectedItem.id;
            }), 1);
            if(this.page.tabs.filter(tab => tab.name == 'Practice Closure')[0].side_panel.dates.options.length == 0) { 
                this.$store.commit('updateOldFormData', new Object())
                this.$store.commit('updateCurrentFormData', new Object())
              }
          }, (error) => {
            console.log(error);
          });
        }
      });
    },
    selectedTabFn(val) {
      this.selectedTab = val;
      this.topbar = this.page.tabs.filter(tab => tab.name == val)[0];
    },
    selectedItemFn(val) {
      this.selectedItem = val;
      this.currentTopicActiveStatus = val.active;
    },
    submit(val, side_panel_val) {
      if(this.selectedTab == 'Regular Hours'){
        var data = {
          additionalProp1: {
            ...this.selectedLocation.additionalProp1,
            regular_hours: this.page.tabs.filter(tab => tab.name == "Regular Hours")[0].side_panel.days.options,
            footnote: side_panel_val.footnote
          },
        };

        api.patch('/api/pages/'+side_panel_val.location.id, data)
        .then(() => {
            Swal.fire("Regular Hours Updated!", "Regular Hours Updated Successfully!", "success");
        }, (error) => {
          console.log(error);
        });
      }
      if(this.selectedTab == 'Practice Closure'){
        var data_holiday = {
          title: val.date,
          active: this.currentTopicActiveStatus,
          additionalProp1: {
            reduced_hours: val.reduced_hours,
            status: val.status,
            opening_time: val.holiday_opening_time,
            closing_time: val.holiday_closing_time,
            second_opening_time: val.holiday_second_opening_time,
            second_closing_time: val.holiday_second_closing_time,
            location_id: this.selectedLocation.id,
            dynamoId: this.currentPractice.additionalProp1.dynamo,       
          }
        };

        api.patch('/api/pages/'+val.id, data_holiday)
        .then(() => {
            this.page.tabs[2].side_panel.dates.options.filter(l => l.id == val.id)[0].title = val.date;         
            this.page.tabs[2].side_panel.dates.options.filter(l => l.id == val.id)[0].additionalProp1.reduced_hours = val.reduced_hours;   
            Swal.fire("Practice Closures Updated!", "Practice Closures Updated Successfully!", "success");
        }, (error) => {
          console.log(error);
        });

        let where = {
          name: {
            like: 'Opening Hours',
            options: "i"
          }
        };

        var cat_data = {
          additionalProp1: {
            description: {
              text: this.category.additionalProp1.text,
            },
            icon: this.category.additionalProp1.icon,
            link: this.category.additionalProp1.link,
            related_information: this.category.additionalProp1.related_information,
            footnote: side_panel_val.holiday_footnote
          },
        };

        api.patch(`/api/cms/${this.currentCms.id}/categories?where=${JSON.stringify(where)}`, cat_data)
        .then(() => {
          this.category.additionalProp1 = cat_data.additionalProp1;
          Swal.fire("Category Updated!", "Category Updated Successfully!", "success");

        }, (error) => {
          console.log(error);
        });
      }
      if(this.selectedTab == 'Description' || this.selectedTab == ''){

        var updated_options = this.page.tabs.filter(tab => tab.name == "Description")[0].form.related_information.options;

        let where = {
          name: {
            like: 'Opening Hours',
            options: "i"
          }
        };

        var content_data = {
          additionalProp1: {
            description: {
              text: val.description,
            },
            icon: this.category.additionalProp1.icon,
            link: this.category.additionalProp1.link,
            related_information: updated_options
          },
        };

        api.patch(`/api/cms/${this.currentCms.id}/categories?where=${JSON.stringify(where)}`, content_data)
        .then(() => {
          this.category.additionalProp1 = content_data.additionalProp1;
          Swal.fire("Category Updated!", "Category Updated Successfully!", "success");

        }, (error) => {
          console.log(error);
        });
      }
    },
    activateToggle() {
      this.currentTopicActiveStatus = !this.currentTopicActiveStatus;
      var data = {
        active: this.currentTopicActiveStatus
      };
      api.patch('/api/pages/'+this.selectedItem.id, data)
      .then(() => {       
          let item = this.page.tabs[2].side_panel.dates.options.filter(l => l.id == this.selectedItem.id)[0];
          item.active = this.currentTopicActiveStatus;
          this.page.tabs[2].side_panel.dates.options.filter(l => l.id == this.selectedItem.id)[0] = item;
          this.$store.commit('updateOldFormData', item)
          this.$store.commit('updateCurrentFormData', item)
          Swal.fire("Topic Status Updated!", "Topic Status Updated Successfully!", "success");
      }, (error) => {
        console.log(error);
      });
    },
    selectedLocationFn(val) {
      this.selectedLocation = val;
    },
    getLocations() {
      api.get(`/api/cms/${this.currentCms.id}/categories`)
      .then((response) => {
        var locationCat = response.data.filter(x => x.name == 'Locations')[0];
          api.get(`/api/categories/${locationCat.id}/pages`)
          .then((response) => {
            this.location_list = response.data;
            this.page.tabs.filter(tab => tab.name == 'Regular Hours')[0].side_panel.location.options = response.data;          
            this.page.tabs.filter(tab => tab.name == 'Practice Closure')[0].side_panel.location.options = response.data;          
          }, (error) => {
            console.log(error);
          });
      }, (error) => {
        console.log(error);
      });
    },
  },
  computed: {
  },
  watch: {
  },
  mounted() {
    this.getLocations();
    this.topbar = this.page.tabs[0];
  }
};
</script>

<template>
  <Layout>
    <Heading :page="topbar" 
      :activeStatus="currentTopicActiveStatus" 
      @activateToggle="activateToggle"
      @created="create" 
      @deleted="deleted" 
      @form-submitted="submit"
    >
    </Heading>
    <FormBuilder :schema="page" :category="category" @selected-tab="selectedTabFn" @submit="submit" @selected-item="selectedItemFn" @selected-location="selectedLocationFn">

    </FormBuilder>
  </Layout>
</template>